<script>
  import CaretRightIcon from "@local/assets/icons/caret-right.svg";
  import CaretLeftIcon from "@local/assets/icons/caret-left.svg";

  export let type = "flex";
  export let position = "right";
  export let expanded = false;
  export let expandable = false;
  // Default-off: when set, the expand caret still renders but is inert (dimmed,
  // no width toggle). Used by FrameX's edit mode; every other caller is
  // unaffected.
  export let expandDisabled = false;
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="flex-none relative h-full bg-white border-l flex flex-col justify-between"
  class:expanded={expanded && position === "right"}
  class:vertical={position === "right"}
  class:relative={type === "flex"}
  class:flex-none={type === "flex"}
  class:absolute={type === "absolute"}
  class:h-full={position === "right"}
  class:right-0={type === "absolute" && position === "right"}
  class:top-0={type === "absolute" && position === "right"}
  class:bottom-0={position === "bottom"}
  class:w-full={position === "bottom"}
  class:left-0={position === "bottom"}
  class:h-56={position === "bottom"}
  on:mousedown|stopPropagation
  on:click|stopPropagation>
  {#if $$slots.header}
    <div class="empty:hidden -mb-4">
      <slot name="header" />
    </div>
  {/if}
  <div class="grow overflow-auto space-y-4 py-4 content-section">
    <slot name="content" />
  </div>
  {#if $$slots.footer}
    <div class="px-2 mb-2 sm:mb-6 pt-2 sm:pt-6 empty:hidden border-t">
      <slot name="footer" />
    </div>
  {/if}
  {#if expandable && position === "right"}
    <button
      class="expand-target"
      class:expand-disabled={expandDisabled}
      disabled={expandDisabled}
      on:click={() => {
        if (expandDisabled) return;
        expanded = !expanded;
      }}>
      <div>
        {#if expanded}
          <CaretRightIcon />
        {:else}
          <CaretLeftIcon />
        {/if}
      </div>
    </button>
  {/if}
</div>

<style lang="scss">
  .vertical {
    width: 20rem;

    &.expanded {
      width: 40rem;
    }
  }

  .expand-target {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 1rem;
    margin-left: -1rem;
    @apply bg-transparent border-transparent border-l;

    &:hover {
      @apply bg-gray-200 border-gray-300;
    }

    // Edit mode: dimmed and inert. Match the left panel — a normal cursor and
    // no hover affordance, not a "not-allowed" badge.
    &.expand-disabled {
      opacity: 0.4;

      &:hover {
        @apply bg-transparent border-transparent;
      }
    }
  }
</style>
